export const UNSUPPORTED_SUBSCRIPTION_CHANGE = 'UNSUPPORTED_SUBSCRIPTION_CHANGE';
export const CONFLICTING_MERCHANDISE_IDS = 'CONFLICTING_MERCHANDISE_IDS';
export const CUSTOMER_DELINQUENT = 'CUSTOMER_DELINQUENT';
export const DEAL_IN_PROGRESS = 'DEAL_IN_PROGRESS';
export const IGNORED_PURCHASE_ORDER_GENERATION_ERRORS = {
  UNSUPPORTED_SUBSCRIPTION_CHANGE,
  CONFLICTING_MERCHANDISE_IDS,
  CUSTOMER_DELINQUENT,
  DEAL_IN_PROGRESS
};